var map = {
	"./avatar1.jpg": 786,
	"./avatar2.jpg": 436,
	"./avatar3.jpg": 699,
	"./avatar4.jpg": 543,
	"./bairdhunt.png": 68,
	"./banecti.png": 1,
	"./bg-texture.png": 560,
	"./bicici.png": 18,
	"./edorer.png": 118,
	"./flappybird.png": 660,
	"./konnect.png": 107,
	"./me-about.png": 951,
	"./me-aboutt.jpg": 371,
	"./me.png": 187,
	"./me.svg": 746,
	"./personal-project-easy-erp.png": 440,
	"./portfolio1.jpg": 437,
	"./portfolio2.jpg": 433,
	"./portfolio3.jpg": 368,
	"./portfolio4.jpg": 678,
	"./portfolio5.png": 493,
	"./portfolio6.jpg": 727,
	"./react-quizz.png": 569,
	"./star.png": 960,
	"./tic-tac-toe.png": 183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;